import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Joinus.css';

export const Joinus: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="join-banner">
      <h2>Join us! It will only take a minute</h2>
      <button onClick={() => navigate('/contact')}>GET STARTED TODAY</button>
    </div>
  );
};
